/* Pill section label used across the landing sections (Features, HowItWorks, */
/* ForWhom, SecuritySection). Extracted from Landing.tsx (decomposition, Phase 4). */
export function SectionLabel({ children, light = false }: { children: string; light?: boolean }) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 16,
        padding: '5px 12px 5px 9px',
        background: light ? 'rgba(255,255,255,0.1)' : 'color-mix(in srgb, var(--naia-blue) 8%, transparent)',
        border: `1px solid ${light ? 'rgba(255,255,255,0.2)' : 'color-mix(in srgb, var(--naia-blue) 18%, transparent)'}`,
        borderRadius: '9999px',
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: '0.12em',
        textTransform: 'uppercase' as const,
        color: light ? 'rgba(255,255,255,0.85)' : 'var(--naia-blue)',
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor', flexShrink: 0 }} />
      {children}
    </div>
  );
}
